import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/fonts/Inter-Variable.woff2\",\"variable\":\"--font-inter\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["AppUpdateBanner"] */ "/app/src/components/app-update-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConnectionMonitor"] */ "/app/src/components/connection-monitor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleAnalytics"] */ "/app/src/components/google-analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/app/src/components/notification-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RecentRoutesTracker"] */ "/app/src/components/recent-routes-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/app/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WSProvider"] */ "/app/src/providers/ws-provider.tsx");
